import React, {useState} from 'react';
import {motion} from 'framer-motion';
import {ContactCTA, Footer, LazyImage, Navbar} from '../../components';
import styles from './Partners.module.css';

const HERO_BG =
    "https://res.cloudinary.com/dhjzovpof/image/upload/v1775853865/5b199b3bd051a9946ee752fc2d12bc372cf9adb4_1_pwibxz.jpg";

const fadeUp = (delay = 0) => ({
    hidden: {opacity: 0, y: 40},
    visible: {opacity: 1, y: 0, transition: {duration: 0.6, ease: 'easeOut', delay}},
});

const PARTNERS = [
    {
        name: 'Dangote Groups',
        logo: "https://res.cloudinary.com/dhjzovpof/image/upload/v1773595837/15fca2915b640c7365bb8c2fbdefffaad5253c81_wuzyda.png",
        overview: "Dangote Group is one of Africa's largest diversified industrial conglomerates, engaged in sectors including cement, sugar, salt, fertiliser, oil refining and petrochemicals. The Group plays a significant role in supporting infrastructure development and industrial growth across Nigeria and the broader West African region, with operations that contribute to economic advancement and community impact.",
        partnership: 'TektronPlus has delivered precision road marking, signage, and traffic management solutions across Dangote Group facilities, ensuring safe and efficient movement of personnel and heavy equipment.',
    },
    {
        name: 'Lagos State Government',
        logo: "https://res.cloudinary.com/dhjzovpof/image/upload/v1773595744/9cd772129b7e29be6977d9d598249eb23d0bfb9e_mjwgit.png",
        overview: "The Lagos State Government is the governing authority of Nigeria's commercial capital, responsible for driving infrastructure development, transportation systems, and sustainable urban growth across the state. Through strategic investments in roads, traffic management, and public utilities, the government continues to enhance mobility, safety, and quality of life for millions of residents.",
        partnership: 'We have partnered with the Lagos State Government on major road marking and traffic management projects spanning Victoria Island, Lekki, Ikoyi, Lagos Island, and key bridges and expressways.',
    },
    {
        name: 'Reynolds Construction Company',
        logo: "https://res.cloudinary.com/dhjzovpof/image/upload/v1773596526/c53ba099e880aaf1511e45aa747054b747a7e12a_nxckmi.jpg",
        overview: 'Reynolds Construction Company (Nigeria) Limited is part of the global construction and development group SBI International Holdings AG, with expertise in civil engineering, roadworks and building projects. Operating across Nigeria, the firm has contributed to diverse infrastructure developments including urban and rural road.',
        partnership: 'TektronPlus has collaborated with RCC on numerous federal and state road projects, providing thermoplastic road markings, directional signs, and highway safety systems to international standards.',
    },
    {
        name: 'Famfa Oil',
        logo: "https://res.cloudinary.com/dhjzovpof/image/upload/v1773595883/8db23edab07c10713d51a29dbe11a7867012206e_hcncgj.png",
        overview: "Famfa Oil Limited is a leading indigenous Nigerian oil and gas company involved in exploration and production. The company has interests in Deepwater offshore operations, including participation in the Agbami Field — one of Nigeria's significant oil assets — and contributes to national energy goals.",
        partnership: 'Our partnership with Famfa Oil covers road marking, signage, and pavement works at their Lagos facility, including the Famfa Towers development on Alfred Rewane Road, Ikoyi.',
    },
    {
        name: 'Borini Prono',
        logo: "https://res.cloudinary.com/dhjzovpof/image/upload/v1773596560/d487c23b3ca496ff8d8dbd73b0e3d2fa70dfeaa4_kbnozn.png",
        overview: "Borini Prono & Company is an international construction firm engaged in large-scale civil engineering and infrastructure works. With a presence across Africa, the company is noted for delivering complex projects that require coordination of multidisciplinary teams.",
        partnership: 'We have provided road marking, directional signs, and traffic management installations for Borini Prono projects including the Third Mainland Bridge rehabilitation and the Apapa Truck Park.',
    },
    {
        name: 'HiTech',
        logo: "https://res.cloudinary.com/dhjzovpof/image/upload/v1773596694/33094e87-7f18-4a9e-aacc-db07a84a3f43_nqet8t.jpg",
        overview: 'HiTech Construction Company is a major civil engineering and construction firm in Nigeria, known for delivering roadworks, bridges, drainage systems, earthworks and related infrastructure projects.',
        partnership: 'TektronPlus collaborated with HiTech on the International Airport Road project, providing road marking and highway signage installations that meet international aviation safety standards.',
    },
    {
        name: 'Adamawa State Government',
        logo: "https://res.cloudinary.com/dhjzovpof/image/upload/v1773595798/ee97329ab3e4210fb3cba3c6f4e051d8785acc41_yv0xoh.png",
        overview: 'The Adamawa State Government is responsible for public administration, infrastructure development and service delivery within Adamawa State. It prioritizes transport, economic development and community welfare as part of its development agenda.',
        partnership: 'Working with the Adamawa State Government, TektronPlus delivered comprehensive road marking and signage programmes across Yola township roads, improving safety for commuters and residents.',
    },
    {
        name: 'China Civil Engineering Construction Corporation Ltd',
        logo: "https://res.cloudinary.com/dhjzovpof/image/upload/v1773595946/b6a21cf5b8da6e5a625df26b4cb2ce22ae33a547_aiih7d.png",
        overview: 'China Civil Engineering Construction Corporation (CCECC) is a global construction and engineering firm with extensive experience in large infrastructure projects, including transportation networks, railways and road systems internationally.',
        partnership: 'TektronPlus has partnered with CCECC on major road projects in Lagos, delivering thermoplastic lane markings, symbols, and directional signage on state highway networks.',
    },
    {
        name: 'Federal Capital Development Authority',
        logo: "https://res.cloudinary.com/dhjzovpof/image/upload/v1773596454/3bfc32097bef7d35ee066b0a21f1edeb1570e3fc_o0dac4.jpg",
        overview: "The Federal Capital Development Authority (FCDA) is the government agency responsible for planning and infrastructure development in Nigeria's capital city, Abuja, ensuring sustainable urban growth and modern public services.",
        partnership: 'Our collaboration with the FCDA spans automatic counting equipment installations, zebra crossings, bus mass transit marking, and parking scheme demarcation across Abuja\'s road network.',
    },
    {
        name: 'Federal Ministry Of Works & Housing',
        logo: "https://res.cloudinary.com/dhjzovpof/image/upload/v1773607719/tektron/asset_010.png",
        overview: 'The Federal Ministry of Works and Housing is the national government body overseeing roads, public infrastructure and housing programmes in Nigeria, guiding policy, standards and implementation at the federal level.',
        partnership: 'TektronPlus has executed major road marking and signage contracts under the Federal Ministry of Works, including the Ilorin–Jebba–Mokwa–Kaduna highway corridor.',
    },
    {
        name: 'China Geo-Engineering Corporation',
        logo: "https://res.cloudinary.com/dhjzovpof/image/upload/v1773596402/b491636cee9b683bf402430b21a1d5725d7df421_ieeamo.jpg",
        overview: 'China Geo-Engineering Corporation is an international engineering and construction company with expertise in civil works, transportation infrastructure, and large-scale public development projects. The organization has delivered complex road, utility, and infrastructure solutions across multiple regions, supporting sustainable urban growth.',
        partnership: 'We have collaborated with China Geo-Engineering on major Nigerian infrastructure corridors, providing road marking and highway safety works that meet federal specifications.',
    },
    {
        name: 'Grandex Plus',
        logo: "https://res.cloudinary.com/dhjzovpof/image/upload/v1773596636/277e699cf9cfa368b5a24ea187689853ca35b70e_ntasrr.png",
        overview: 'Grandex Plus Nigeria Limited is a property development company focused on delivering modern residential, commercial, and mixed-use facilities. With an emphasis on quality construction and functional environments, the company develops spaces that promote accessibility, safety, and long-term value for occupants and communities.',
        partnership: 'TektronPlus delivered parking lot demarcation, speed bumps, and road signage at the Grandex development, creating safe and organized vehicle management infrastructure.',
    },
    {
        name: 'Zenith Medical And Kidney Centre',
        logo: "https://res.cloudinary.com/dhjzovpof/image/upload/v1773596492/76fb165b7f38d60046af371794d62b327ef9830a_yjdwmd.png",
        overview: "Zenith Medical & Kidney Centre is a specialized healthcare institution offering advanced medical and renal care services within a purpose-built facility. The center is committed to delivering high standards of patient care supported by safe, efficient, and well-organized infrastructure.",
        partnership: 'TektronPlus completed asphalt laying and hospital grounds overlay works at the Zenith Medical & Kidney Centre facility in Abuja, ensuring safe access for staff, patients, and emergency vehicles.',
    },
    {
        name: 'ST. Agnes Catholic Church',
        logo: "https://res.cloudinary.com/dhjzovpof/image/upload/v1773596591/00dcdb348ac8aa2f659387c1818b1cbd35651489_invtgq.png",
        overview: 'St. Agnes Catholic Church is a long-standing religious and community institution located in Maryland, Lagos, serving a large congregation and hosting regular services, events, and gatherings. The facility accommodates significant vehicular and pedestrian traffic, requiring organized and safe site planning.',
        partnership: 'TektronPlus provided parking demarcation, pedestrian markings, and road safety installations at the St. Agnes Catholic Church facility to manage high volumes of congregational traffic.',
    },
    {
        name: 'Planet Projects',
        logo: "https://res.cloudinary.com/dhjzovpof/image/upload/v1773596347/59b96960693b33f7199681ef66432a1a5c5e1338_t2g6dp.png",
        logoBg: '#404040',
        overview: 'Planet Projects Limited is an engineering and construction company engaged in infrastructure and development projects across Nigeria, with capabilities spanning civil works, road construction, and site development. The company focuses on delivering durable, high-quality solutions that support long-term community growth.',
        partnership: 'Our extensive partnership with Planet Projects spans road marking, traffic signal installations, and junction management across Lagos, Abuja, Imo, Edo, and Oyo states.',
    },
];

function PartnerCard({partner, delay}) {
    const [tab, setTab] = useState('overview');

    return (
        <motion.div
            className={styles.partnerCard}
            variants={fadeUp(delay)}
            initial="hidden"
            whileInView="visible"
            viewport={{once: true, amount: 0.15}}
        >
            <div className={styles.cardInner}>
                {/* Logo area */}
                <div className={styles.logoArea}>
                    <div
                        className={styles.logoWrap}
                        style={partner.logoBg ? {background: partner.logoBg} : undefined}
                    >
                        <img
                            src={partner.logo}
                            alt={partner.name}
                            className={styles.logoImg}
                        />
                    </div>
                </div>

                {/* Text */}
                <div className={styles.cardText}>
                    <div className={styles.nameWrapper}>
                        <h3 className={styles.partnerName}>{partner.name}</h3>
                    </div>
                    <div className={styles.tabSection}>
                        <div className={styles.tabRow}>
                            <button
                                className={`${styles.tabBtn} ${tab === 'overview' ? styles.tabActive : styles.tabInactive}`}
                                onClick={() => setTab('overview')}
                            >
                                Overview
                            </button>
                            <button
                                className={`${styles.tabBtn} ${tab === 'partnership' ? styles.tabActive : styles.tabInactive}`}
                                onClick={() => setTab('partnership')}
                            >
                                Our Partnership
                            </button>
                        </div>
                        <p className={styles.description}>
                            {tab === 'overview' ? partner.overview : partner.partnership}
                        </p>
                    </div>
                </div>
            </div>
        </motion.div>
    );
}

export default function Partners() {
    return (
        <div className={styles.page}>
            <Navbar theme="light" cta="Contact Us" ctaTo="/contact"/>

            {/* ── HERO ──────────────────────────────────────────── */}
            <section className={styles.hero}>
                <div className={styles.heroBg} aria-hidden="true">
                    <LazyImage src={HERO_BG} alt="" className={styles.heroBgImg}/>
                    <div className={styles.heroGradient}/>
                </div>
                <div className={styles.heroLabel}>
                    <h1 className={styles.heroTitle}>OUR PARTNERS</h1>
                </div>
            </section>

            {/* ── CONTENT ───────────────────────────────────────── */}
            <div className={styles.contentSection}>
                {/* Section header */}
                <motion.div
                    className={styles.sectionHeader}
                    variants={fadeUp(0)}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{once: true, amount: 0.3}}
                >
                    <h2 className={styles.headerTitle}>BRANDS THAT TRUST OUR VISION</h2>
                    <p className={styles.headerDesc}>
                        We collaborate with leading government agencies and private sector giants to deliver
                        infrastructure that drives national progress and environmental resilience.
                    </p>
                </motion.div>

                {/* Cards grid */}
                <div className={styles.cardsGrid}>
                    {PARTNERS.map((p, i) => (
                        <PartnerCard key={p.name} partner={p} delay={(i % 2) * 0.08}/>
                    ))}
                </div>
            </div>

            <ContactCTA/>
            <Footer/>
        </div>
    );
}
